const PROPS_ERROR_MESSAGE =
  "This component don't accept an action button prop with children prop at the same time =P";
const DISPLAY_DATA_DIVIDER_ID = 'display-data-divider';
const DISPLAY_DATA_LABEL_ID = 'display-data-label';
const DISPLAY_DATA_TOGGLE_CHILD_BUTTON_ID = 'display-data-toggle-address-btn';
const DISPLAY_DATA_ACTION_BUTTON_ID = 'display-data-action-btn';
const DISPLAY_DATA_SEE_MORE_BUTTON_ID = 'display-data-see-more-btn';

export {
  PROPS_ERROR_MESSAGE,
  DISPLAY_DATA_LABEL_ID,
  DISPLAY_DATA_DIVIDER_ID,
  DISPLAY_DATA_TOGGLE_CHILD_BUTTON_ID,
  DISPLAY_DATA_ACTION_BUTTON_ID,
  DISPLAY_DATA_SEE_MORE_BUTTON_ID
};
